/**
 * Header Navigation - Todo en uno
 */
(function() {
    'use strict';

    // Elementos DOM
    const header = document.getElementById('main-header');
    const menuOverlay = document.getElementById('menu');
    const btnAbreMenu = document.getElementById('abre-menu');
    const btnCierraMenu = document.getElementById('cerrar-menu');
    const body = document.body;

    // Estado
    let menuAbierto = false;

    /**
     * Abrir menú
     */
    function abrirMenu() {
        if (!menuOverlay) return;

        menuAbierto = true;
        menuOverlay.classList.add('visible');
        body.style.overflow = 'hidden';

        // Animar los enlaces
        const links = menuOverlay.querySelectorAll('.menu-overlay__link');
        links.forEach((link, index) => {
            setTimeout(() => {
                link.style.opacity = '1';
                link.style.transform = 'translateX(0)';
            }, index * 50);
        });
    }

    /**
     * Cerrar menú
     */
    function cerrarMenu() {
        if (!menuOverlay || !menuAbierto) return;

        menuAbierto = false;

        // Resetear animación de enlaces
        const links = menuOverlay.querySelectorAll('.menu-overlay__link');
        links.forEach(link => {
            link.style.opacity = '0';
            link.style.transform = 'translateX(-100%)';
        });

        setTimeout(() => {
            menuOverlay.classList.remove('visible');
            body.style.overflow = '';
        }, 300);
    }

    /**
     * Manejo del scroll del header
     */
    function manejarScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 5) {
            header?.classList.add('scroll');
            body.classList.add('scroll');
        } else {
            header?.classList.remove('scroll');
            body.classList.remove('scroll');
        }
    }

    /**
     * Scroll suave a una posición
     */
    function scrollSuave(posicion) {
        window.scrollTo({
            top: posicion,
            behavior: 'smooth'
        });
    }

    /**
     * Inicializar todo
     */
    function init() {
        // Abrir menú
        if (btnAbreMenu) {
            btnAbreMenu.addEventListener('click', abrirMenu);
        }

        // Cerrar menú
        if (btnCierraMenu) {
            btnCierraMenu.addEventListener('click', cerrarMenu);
        }

        // Cerrar con ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && menuAbierto) {
                cerrarMenu();
            }
        });

        // Scroll del header
        window.addEventListener('scroll', manejarScroll);

        // Botón scroll to top
        const btnUp = document.querySelector('.up');
        if (btnUp) {
            btnUp.addEventListener('click', (e) => {
                e.preventDefault();
                scrollSuave(0);
            });
        }

        // Enlaces scroll-to
        const scrollLinks = document.querySelectorAll('.scroll-to');
        scrollLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                let targetId = this.dataset.scroll_to || this.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    const altoCabecera = 80;
                    const targetPosition = targetElement.offsetTop - altoCabecera;
                    scrollSuave(targetPosition);
                }
            });
        });

        console.log('Header inicializado');
    }

    // Inicializar cuando esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
